import { IntlShape } from 'react-intl/src/types';

import { FilterItemModel } from '../models/filter.model';
import { DataSchemeFilter } from '../store/location';

export const resetFilterData = (data: DataSchemeFilter): DataSchemeFilter => {
    const filterData: DataSchemeFilter = { ...data };

    for (const [key, value] of Object.entries(filterData)) {
        const keyFilter = key as keyof DataSchemeFilter;

        (filterData[keyFilter] as FilterItemModel[]) = (value as FilterItemModel[])?.map(
            (el: FilterItemModel): FilterItemModel => {
                if (keyFilter !== 'bookingyear') {
                    if (el.subnodes) {
                        return {
                            ...el,
                            checked: false,
                            subnodes: el.subnodes.map(child => {
                                const result = { ...child, checked: false };
                                if (child.subnodes) {
                                    result.subnodes = child.subnodes.map(subchild => ({ ...subchild, checked: false }));
                                }
                                return result;
                            }),
                        };
                    }
                    return { ...el, checked: false };
                } else {
                    return el;
                }
            }
        );
    }

    return filterData;
};

export const getLabelFilterBlock =
    (intl: IntlShape) =>
    (key: keyof DataSchemeFilter): string => {
        const values: Record<string, string> = {
            attributes: intl.formatMessage({
                id: 'location.filter.labels.attribute',
                defaultMessage: 'Flächeneigenschaften',
            }),
            category: intl.formatMessage({
                id: 'location.filter.labels.category',
                defaultMessage: 'Produkt',
            }),
            commspace: intl.formatMessage({
                id: 'location.filter.labels.commspace',
                defaultMessage: 'Kommunikationsraum',
            }),
            distribution: intl.formatMessage({
                id: 'location.filter.labels.distribution',
                defaultMessage: 'Plakatnetze',
            }),
            duration: intl.formatMessage({
                id: 'location.filter.labels.duration',
                defaultMessage: 'Laufzeit',
            }),
            format: intl.formatMessage({
                id: 'location.filter.labels.format',
                defaultMessage: 'Format',
            }),
            pricerange: intl.formatMessage({
                id: 'location.filter.labels.pricerange',
                defaultMessage: 'Preis',
            }),
            region: intl.formatMessage({
                id: 'location.filter.labels.region',
                defaultMessage: 'Sprachregion',
            }),
            type: intl.formatMessage({
                id: 'location.filter.labels.type',
                defaultMessage: 'Werbeart',
            }),
            restrictions: intl.formatMessage({
                id: 'location.filter.labels.restrictions',
                defaultMessage: 'Branchenverträglichkeit',
            }),
        };

        return values[key];
    };
